
import { NavigationConstant } from "./NavigationConstant";

const NavigationAction = {};

NavigationAction.getNavigationData = ({to_date,from_date,search_term,limit,page, sorting}) => {
   
    return {
        type: NavigationConstant.NAVIGATION_SAGA, 
        payload: {
            to_date:to_date,
            from_date:from_date,
            search_term:search_term,
            limit:limit,
            page:page,
            sorting:sorting

        }
    }
};


export { NavigationAction };